
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tickets/[...slug]",
      function () {
        return require("private-next-pages/tickets/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tickets/[...slug]"])
      });
    }
  